const PropTypes = require('prop-types');
const React = require('react');
const MultiOrderCustoms = require('../multi_order_customs');
const {
  store: ShippingLabelStore,
  actions: ShippingLabelActions,
} = require('../shipping_label_form_module');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

function mapper() {
  const {
    selectedOrders,
    insurancePolicy,
    originCountries,
    shipment,
  } = ShippingLabelStore.getState();
  let aboveMaximumIntlDeclaredValueThreshold = false;
  let formattedTotalDeclaredValue = '';
  let maximumDeclaredValue = '';
  let needsCustoms = false;
  let orders = [];

  if (insurancePolicy) {
    aboveMaximumIntlDeclaredValueThreshold = insurancePolicy.aboveMaximumIntlDeclaredValueThreshold;
    formattedTotalDeclaredValue = insurancePolicy.formattedTotalDeclaredValue;
    maximumDeclaredValue = insurancePolicy.formattedMaximumDeclaredValue;
  }

  if (shipment) {
    needsCustoms = shipment.needsCustoms;
  }

  if (selectedOrders) {
    orders = selectedOrders.ordersPrimaryFirst;
  }

  return {
    aboveMaximumIntlDeclaredValueThreshold,
    formattedTotalDeclaredValue,
    orders,
    maximumDeclaredValue,
    needsCustoms,
    originCountries: originCountries || [],
  };
}

const WrappedMultiOrderCustoms = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(MultiOrderCustoms, 'MultiOrderCustoms');

class MultiOrderCustomsContainer extends React.Component {
  componentDidMount() {
    ShippingLabelActions.fetchOriginCountries();
  }

  render() {
    return (
      <WrappedMultiOrderCustoms
        errorMessage={this.props.errorMessage}
      />
    );
  }
}

MultiOrderCustomsContainer.propTypes = {
  errorMessage: PropTypes.string,
};

module.exports = MultiOrderCustomsContainer;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/multi_order_customs_container.jsx